/**
 * The swappable seam around the one dynamic `import()` the runtime performs (layered shell
 * surfaces, D12). Moved in shape from the shell's `app-bundle-importer.ts`.
 *
 * Vitest routes `import()` through Vite's module runner, which refuses arbitrary `https:` and
 * query-suffixed URLs, and msw intercepts `fetch`, never the ESM loader. So tests install
 * `FakeBundleImporter` from `./testing` through {@link setSurfaceBundleImporter} and assert what
 * renders; production keeps the native `import()`.
 */
/** The native importer. `@vite-ignore` keeps a bundler from resolving the runtime-only URL. */
const nativeImporter = (url) => import(/* @vite-ignore */ url);
let importer = nativeImporter;
/**
 * Import one bundle through the installed importer, the native `import()` by default. Rejects with
 * whatever the importer rejects with; a browser rejects a failed import with an opaque `TypeError`.
 */
export function importSurfaceBundle(url) {
    return importer(url);
}
/**
 * Install `next` as the importer. Returns a function that restores the importer that was active
 * before this call. Test seam; production never calls it.
 */
export function setSurfaceBundleImporter(next) {
    const previous = importer;
    importer = next;
    return () => {
        importer = previous;
    };
}
/** Put the native importer back. `resetSurfaceRuntime` in `./testing` is the only caller. */
export function resetSurfaceBundleImporter() {
    importer = nativeImporter;
}
//# sourceMappingURL=bundle-importer.js.map